<template>
  <div id="agenda_por_profissional" class="row">
    <div class="col-md-5">
      <div class="form-group form-group-periodo">
        <label>Período</label>
        <date-range-picker
          ref="picker"
          :opens="'right'"
          :locale-data="localeData"
          :minDate="minDate"
          :maxDate="maxDate"
          :autoApply="true"
          :ranges="ranges"
          v-model="dateRange"
          @update="onDateRangeChange"
        >
          <template v-slot:input="picker" style="min-width: 350px">
            {{ formatDate(picker.startDate) }} -
            {{ formatDate(picker.endDate) }}
          </template>
        </date-range-picker>
      </div>
    </div>
    <div class="col-md-12">
      <div class="info-table justify-content-end">
        <div class="select-situacao info-table-item">
          <vue-select
            :options="optionsFilterProfissional"
            label="label"
            placeholder="Profissional"
            v-model="filterProfissional"
            @input="handleSelectChangeFilterProfissional"
            :clearable="true"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="agenda-por-profissional"
          >
          </download-files>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import Subtitle from './Subtitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import DateRangePicker from 'vue2-daterange-picker'
export default {
  name: 'AgendaPorProfissional',
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
    DateRangePicker,
  },
  data() {
    return {
      cadastros: [],
      loading: false,
      profissional: null,
      cadastrosOriginais: [],
      setRed: false,
      disabledRed: false,
      disabledGreen: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
      dateRange: {
        startDate: null,
        endDate: null,
      },
      localeData: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'S',
        customRangeLabel: 'Intervalo personalizado',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        firstDay: 0,
      },
      ranges: {
        'Esta semana': [
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay())
          ),
          new Date(),
        ],
        'Semana passada': [
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay() - 7)
          ),
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay() - 1)
          ),
        ],
        'Este mês': [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(),
        ],
        'Mês passado': [
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
          new Date(new Date().getFullYear(), new Date().getMonth(), 0),
        ],
        'Este quadrimestre': [
          new Date(
            new Date().getFullYear(),
            Math.floor(new Date().getMonth() / 4) * 4,
            1
          ),
          new Date(),
        ],
        'Quadrimestre passado': [
          this.getQuadrimestrePassadoStartDate(),
          new Date(
            new Date().getFullYear(),
            Math.floor(new Date().getMonth() / 4) * 4,
            0
          ),
        ],
      },
      minDate: null,
      maxDate: null,
      optionsFilterProfissional: [],
      filterProfissional: null,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    handleSelectChangeFilterProfissional(selectedValue) {
      if (selectedValue !== null) {
        this.filterProfissional = selectedValue
      }
      this.filtros()
    },

    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    limparFiltrosDeData() {
      this.dateRange = { startDate: null, endDate: null }
      this.dataFiltrada = false
      this.filtros()
    },
    getQuadrimestrePassadoStartDate() {
      const now = new Date()
      const month = now.getMonth()
      const year = now.getFullYear()
      const startMonth = Math.floor((month - 4) / 4) * 4
      return new Date(year, startMonth, 1)
    },
    getQuadrimestreAtualStartDate() {
      const now = new Date()
      const month = now.getMonth()
      const year = now.getFullYear()
      const startMonth = Math.floor(month / 4) * 4
      return new Date(year, startMonth, 1)
    },
    formatDate(date) {
      if (!date) return ''
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      return new Date(date).toLocaleDateString('pt-BR', options)
    },

    onDateRangeChange(range) {
      this.dateRange = range
      this.filtros()
    },

    filtros() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }

      let data = this.cadastrosOriginais

      if (this.microArea !== '' && this.microArea !== null) {
        data = data.filter((el) => {
          return el.micro_area == this.microArea
        })
      }
      if (this.dateRange.startDate && this.dateRange.endDate) {
        const startDate = new Date(this.dateRange.startDate)
        startDate.setHours(0, 0, 0, 0)

        const endDate = new Date(this.dateRange.endDate)
        endDate.setHours(23, 59, 59, 999)

        const startDateTimestamp = startDate.getTime()
        const endDateTimestamp = endDate.getTime()

        data = data.filter((dado) => {
          const [datePart, timePart] = dado.dt_hr_agendamento.split(' ')
          const [year, month, day] = datePart.split('-').map(Number)
          const [hour, minute, second] = timePart.split(':').map(Number)

          // Criar um novo objeto Date no UTC
          const dt_hr_agendamento = new Date(
            Date.UTC(year, month - 1, day, hour, minute, second)
          ).getTime()

          return (
            dt_hr_agendamento >= startDateTimestamp &&
            dt_hr_agendamento <= endDateTimestamp
          )
        })
      }

      if (this.filterProfissional !== null) {
        data = data.filter(
          (item) => item.cbo_fam === this.filterProfissional.value
        )
      }
      this.cadastros = data
    },

    async init() {
      try {
        this.loading = true
        const response = await Functions.getDadosData(
          this.$store.state.cod_ibge
        )
        this.cadastros = response
        this.cadastrosOriginais = response
        this.optionsFilterProfissional = Functions.formatOptionsProfissional(
          this.cadastrosOriginais
        )
        this.microArea = this.$store.state.micro_area
        this.filtros()
        this.setRed = true
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        '',
        this.$store.state.micro_area
      )
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
#agenda_por_profissional .select-situacao .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#agenda_por_profissional .select-situacao .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#agenda_por_profissional .select-situacao .v-select {
  width: 296px;
}
#agenda_por_profissional .select-situacao .vs__dropdown-toggle {
  background-color: #fff;
}
#botaoLimparFiltros {
  margin-bottom: -12px;
  background-color: transparent;
  border: none;
  box-shadow: 0 0px 0px 0 rgb(0 0 0 / 0%), 0 3px 1px -2px rgba(0, 0, 0, -3.8),
    0 1px 5px 0 rgba(0, 0, 0, -5.88);
  margin-left: -180px;
  font-size: 20px;
}

#agenda_por_profissional .form-group {
  margin-bottom: 15px;
}

#agenda_por_profissional .form-group-periodo {
  display: flex;
  flex-direction: column;
}
#botaoLimparFiltros .icone-cinza-escuro {
  color: #555;
}

@media (max-width: 767px) {
  #botaoLimparFiltros {
    display: none;
  }
}
#agenda_por_profissional .calendars {
  width: 680px;
}
</style>
